export default {"src":"/_next/static/media/SFM.15abc15c.svg","height":18,"width":18};